module.exports = __webpack_public_path__ + "static/media/appsumo.b80deed6.svg";